module.exports = __webpack_public_path__ + "static/office-setup-6b6f03461136cc5851072ef2587f7c94.svg";